import React from 'react';
import { History, Play, Download, ChevronRight } from 'lucide-react';
const agents = [{
  id: '1',
  name: 'Paper & Pulp Commodity Exposure',
  riskLevel: 'Medium',
  riskColor: 'yellow',
  summary: 'Pulp costs up 9% YoY while print media demand continues to soften industry-wide. Margins are holding for now, but input cost pressure is worth watching next quarter.',
  lastRun: 'May 14, 2026 3:41 PM'
}, {
  id: '2',
  name: 'Sabre Corp Ownership & Parent Risk',
  riskLevel: 'Low',
  riskColor: 'green',
  summary: 'Operates as a subsidiary of publicly traded Sabre Corporation. Parent leverage is moderate at 2.1x EBITDA with no dividend recap activity detected.',
  lastRun: 'May 14, 2026 1:20 PM'
}, {
  id: '3',
  name: 'Regional Customer Concentration',
  riskLevel: 'Medium',
  riskColor: 'yellow',
  summary: 'Roughly 35% of revenue tied to a handful of regional corporate accounts. Competitive pressure from national office-supply chains continues to squeeze smaller branches.',
  lastRun: 'May 13, 2026 4:05 PM'
}, {
  id: '4',
  name: 'Legal, Litigation & Public Records',
  riskLevel: 'Low',
  riskColor: 'green',
  summary: 'No active lawsuits or liens on record. One resolved employment dispute in 2024. Clean standing with state and local filings.',
  lastRun: 'May 13, 2026 2:47 PM'
}];
function RiskBadge({
  level,
  color
}: {
  level: string;
  color: string;
}) {
  const bgColor = color === 'green' ? 'bg-green-100 text-green-800 border-green-300' : color === 'yellow' ? 'bg-yellow-100 text-yellow-800 border-yellow-300' : 'bg-red-100 text-red-800 border-red-300';
  return <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border ${bgColor}`} data-id="element-1202" data-mp="ckqvw9oyfwdk">
      {level}
    </span>;
}
export function DunderMifflinResearchAgentsTab() {
  return <div className="space-y-6" data-id="element-1203" data-mp="3g1zbso04gm5n">
      {/* Header */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-1204" data-mp="9ls3atcpeibc">
        <div className="flex items-center justify-between" data-id="element-1205" data-mp="dmu3pdicx0ew">
          <p className="text-sm text-gray-600" data-id="element-1206" data-mp="dlaozrccmxf8">
            Click Run All to start the agents, or run them individually.
          </p>
          <div className="flex items-center gap-3" data-id="element-1207" data-mp="ncnfofmevhjo">
            <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1208" data-mp="nbc3psitb3hh">
              <History className="w-4 h-4" data-id="element-1209" data-mp="3qsuarxqrg6gu" />
              HISTORY
            </button>
            <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1210" data-mp="3vsqbno45vhs6">
              <Play className="w-4 h-4" data-id="element-1211" data-mp="4k2px720dsk3" />
              RUN ALL
            </button>
          </div>
        </div>
      </div>

      {/* Risk Summary */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-1212" data-mp="1g0j99bgootc8">
        <div className="p-6 border-b border-gray-200 flex items-center justify-between" data-id="element-1213" data-mp="30jwlnimz4xx0">
          <div className="flex items-center gap-3" data-id="element-1214" data-mp="2vjqmlhedk94w">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-1215" data-mp="2vl20wb5g4za9">Risk Summary</h2>
            <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-800 border border-yellow-300" data-id="element-1216" data-mp="2qs8wxphsxuz8">
              Medium
            </span>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1217" data-mp="2hugggi0cgha9">
            <Download className="w-4 h-4" data-id="element-1218" data-mp="27twd99t9l2pe" />
            EXPORT CSV
          </button>
        </div>

        {/* Agents Table */}
        <div className="overflow-x-auto" data-id="element-1219" data-mp="22x5xyopaab51">
          <table className="w-full text-left border-collapse" data-id="element-1220" data-mp="63cky2cxseje">
            <thead data-id="element-1221" data-mp="62jihdl0gb72">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-1222" data-mp="60yobp2lyu9q">
                <th className="px-6 py-3 text-sm font-semibold text-gray-600 w-1/5" data-id="element-1223" data-mp="14rfnoitv4o3">
                  Agent
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600 w-32 text-center" data-id="element-1224" data-mp="9338o0bl74hp">
                  Risk Level
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-1225" data-mp="3vb45yxgt3wbt">
                  Summary
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600 w-48 text-center" data-id="element-1226" data-mp="43zzq4shke4g">
                  Last Run
                </th>
                <th className="px-6 py-3 w-12" data-id="element-1227" data-mp="3raaiu6b6uljz"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1228" data-mp="3clo52917m1uv">
              {agents.map(agent => <tr key={agent.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-1229" data-mp="3hkqyew7tujn0">
                  <td className="px-6 py-4" data-id="element-1230" data-mp="33m10xfh3ihy4">
                    <span className="font-semibold text-gray-900" data-id="element-1231" data-mp="33nc3xd2pvlo6">
                      {agent.name}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-center" data-id="element-1232" data-mp="2ozamrdi9wuv4">
                    <div className="flex justify-center" data-id="element-1233" data-mp="2jz67trx0k870">
                      <RiskBadge level={agent.riskLevel} color={agent.riskColor} data-id="element-1234" data-mp="2k0r2rin8pt5e" />
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-1235" data-mp="2syb5yx4nxzin">
                    <p className="text-sm text-gray-700 leading-relaxed" data-id="element-1236" data-mp="37wvdyr8ig5iw">
                      {agent.summary}
                    </p>
                  </td>
                  <td className="px-6 py-4" data-id="element-1237" data-mp="32xs7r3gsnt9c">
                    <div className="flex items-center justify-center gap-2 text-sm text-gray-600" data-id="element-1238" data-mp="3gp70w34f1au4">
                      <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-1239" data-mp="3co3l1gmdbesw"></span>
                      {agent.lastRun}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-1240" data-mp="3qlikle6c52yl">
                    <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-1241" data-mp="3lpbad96wp5au">
                      <ChevronRight className="w-5 h-5 text-gray-400" data-id="element-1242" data-mp="2jbngbmrz804b" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}